// extracted by mini-css-extract-plugin
export var phone = "_3v-0";
export var phoneDragging = "_3v-1";